// FS-2026-065: offer the two published document languages before acceptance.
import { TextField } from "@mui/material";
import { useTranslate } from "src/locales";

export default function LegalLanguageSelect({
  disabled = false,
}: {
  disabled?: boolean;
}) {
  const { t, i18n, onChangeLang } = useTranslate();
  const language = i18n.language?.split("-")[0] === "hu" ? "hu" : "en";
  return (
    <TextField
      select
      size="small"
      disabled={disabled}
      label={t("platform_legal_language")}
      value={language}
      SelectProps={{ native: true }}
      InputLabelProps={{ shrink: true }}
      sx={{ minWidth: 160, flexShrink: 0 }}
      onChange={(event) => {
        const next = event.target.value;
        if (next !== "hu" && next !== "en") return;
        try {
          localStorage.setItem("i18nextLng", next);
          document.cookie = `i18nextLng=${next}; Path=/; Max-Age=31536000; SameSite=Lax`;
        } catch {
          /* The in-memory language choice still works with blocked storage. */
        }
        onChangeLang(next);
      }}
    >
      <option value="hu" translate="no">
        Magyar
      </option>
      <option value="en" translate="no">
        English
      </option>
    </TextField>
  );
}
